import { render, staticRenderFns } from "./DialogChangeTransferStatusDriverAdmin.vue?vue&type=template&id=1e5e52d2&"
import script from "./DialogChangeTransferStatusDriverAdmin.vue?vue&type=script&lang=js&"
export * from "./DialogChangeTransferStatusDriverAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e5e52d2')) {
      api.createRecord('1e5e52d2', component.options)
    } else {
      api.reload('1e5e52d2', component.options)
    }
    module.hot.accept("./DialogChangeTransferStatusDriverAdmin.vue?vue&type=template&id=1e5e52d2&", function () {
      api.rerender('1e5e52d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogChangeTransferStatusDriverAdmin.vue"
export default component.exports